import React from 'react';
import { ROADMAP_DATA } from '../../config/constants';

const Roadmap: React.FC = () => {
    return (
        <section id="roadmap" className="section">
            <h2 className="section-title">🗺️ Roadmap</h2>

            <div className="roadmap-container">
                {ROADMAP_DATA.map((phase, index) => (
                    <div
                        key={index}
                        className={`glass-card roadmap-phase ${phase.status}`}
                    >
                        <h3 className="roadmap-title">
                            {phase.status === 'completed' && '✅ '}
                            {phase.status === 'current' && '🔥 '}
                            {phase.status === 'upcoming' && '🚀 '}
                            {phase.title}
                        </h3>
                        <ul className="roadmap-items">
                            {phase.items.map((item, itemIndex) => (
                                <li key={itemIndex} className="roadmap-item">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Roadmap;
